module.exports = __webpack_public_path__ + "img/ftm.008792cb.svg";